// Returns true if the element is visible (not display: none, not hidden, etc.)
export function isVisible(element: HTMLElement): boolean {
  // Check the element and all its parents
  let el: HTMLElement | null = element;
  while (el) {
    if (el.getAttribute('aria-hidden') === 'true') return false;
    if (el.hasAttribute('hidden')) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    el = el.parentElement;
  }
  // Physical visibility
  return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}
